<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";

import { useForm } from "@inertiajs/vue3";
import VMultiText from "../../Form/Survey/VMultiText.vue";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";
import intus from "intus";
import { isRequired, isMax, isMin, isInteger } from "intus/rules";
import isArrayNoEmptyValue from "../../../Plugins/rules/isArrayNoEmptyValue";

import { scrollOnError } from "@/Helpers/validation";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    why_did_you_select_sabah_as_a_holidayvacation_destination:
        answers?.why_did_you_select_sabah_as_a_holidayvacation_destination ??
        [],
    what_influenced_you_to_choose_sabah_as_holidayvacation_destination:
        answers?.what_influenced_you_to_choose_sabah_as_holidayvacation_destination ??
        [],
    how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
        answers?.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(form.data(), {
        why_did_you_select_sabah_as_a_holidayvacation_destination: [
            isRequired(),
            isArrayNoEmptyValue(),
        ],
        what_influenced_you_to_choose_sabah_as_holidayvacation_destination: [
            isRequired(),
            isArrayNoEmptyValue(),
        ],
        how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
            [isRequired()],
    });

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-4">
                    <VMultiText
                        elId="why_did_you_select_sabah_as_a_holidayvacation_destination"
                        v-model:value="
                            form.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="what_influenced_you_to_choose_sabah_as_holidayvacation_destination"
                        v-model:value="
                            form.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VRadioWithBlockLabel
                        elId="how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah"
                        v-model:value="
                            form.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah
                        "
                        :label="
                            surveyFields[
                                'how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="
                            form.errors
                                ?.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah
                        "
                    />
                </div>
            </div>
        </div>
        <VDevider />
        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                Next
            </VButtonSubmit>
        </div>
    </div>
</template>
